import { APIProvider, Map } from "@vis.gl/react-google-maps";
import React, { useContext, useEffect, useRef, useState } from "react";
import { GOOGLE_MAPS_API_KEY } from "../../../constants";
import { DEFAULT_CENTER, DEFAULT_ZOOM, MIN_ZOOM } from "../constants";
import { OnDemandContext } from "../context";
import { getUserPoisition } from "../lib";
import { NavigationControls } from "./NavigationControls";
import { PathLine } from "./PathLine";
import { RadiusMarker } from "./RadiusMarker";
import { TourAreaControls } from "./TourAreaControls";

import "./MapScreen.css";

export function MapScreen() {
  const mapId = useRef(crypto.randomUUID()).current;
  const isDraggingPoint = useRef(false);
  const [zoom, setZoom] = useState(DEFAULT_ZOOM);
  const [center, setCenter] = useState(DEFAULT_CENTER);
  const {
    mode,
    startingPoint,
    endingPoint,
    changeStartingPoint,
    changeEndingPoint,
    resetTourGeography,
  } = useContext(OnDemandContext);

  const locateUser = async () => {
    const latLng = await getUserPoisition();
    setCenter(latLng);
    resetTourGeography(latLng);
  };

  useEffect(() => {
    if (startingPoint) {
      setCenter(startingPoint);
    } else {
      locateUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePointDragStart = () => {
    isDraggingPoint.current = true;
  };
  const handlePointDragEnd = () => {
    /**
     * Таймаут нужен, чтобы предотвратить ложные
     * срабатывания onClick карты после перетаскивания
     */
    setTimeout(() => {
      isDraggingPoint.current = false;
    });
  };

  const handleMapClick = e => {
    if (isDraggingPoint.current) return;

    const { latLng } = e.detail;

    switch (mode) {
      case "path":
        if (!startingPoint) return changeStartingPoint(latLng);
        if (!endingPoint) return changeEndingPoint(latLng);
        changeStartingPoint(latLng);
        changeEndingPoint(null);
        break;
      case "radius":
        changeStartingPoint(latLng);
        changeEndingPoint(null);
        break;
      default:
        throw Error("Unknown map mode: ", `"${mode}"`);
    }
  };

  const mapOptions = {
    restriction: {
      latLngBounds: {
        north: 85,
        south: -85,
        west: -180,
        east: 180,
      },
      strictBounds: true,
    },
    disableDefaultUI: true,
    gestureHandling: "greedy",
  };

  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
      <div className="map-screen">
        {typeof window === "object" && (
          <Map
            disableDefaultUI
            mapId={mapId}
            minZoom={MIN_ZOOM}
            style={{ width: "100%", height: "100%" }}
            zoom={zoom}
            defaultCenter={DEFAULT_CENTER}
            center={center}
            options={mapOptions}
            gestureHandling="greedy"
            onZoomChanged={e => setZoom(e.detail.zoom)}
            onClick={handleMapClick}
            /**
             * После центровки карты на пользователе,
             * нужно сбросить center, чтобы карту можно было проматывать.
             */
            onCenterChanged={() => setCenter(undefined)}
          >
            <TourAreaControls />

            <NavigationControls
              onZoomIn={() => setZoom(state => state + 1)}
              onZoomOut={() =>
                setZoom(state => {
                  const newZoom = state - 1;
                  return newZoom < MIN_ZOOM ? MIN_ZOOM : newZoom;
                })
              }
              onLocateUser={locateUser}
            />

            {
              {
                radius: <RadiusMarker />,
                path: (
                  <PathLine
                    onPointDragStart={handlePointDragStart}
                    onPointDragEnd={handlePointDragEnd}
                  />
                ),
              }[mode]
            }
          </Map>
        )}
      </div>
    </APIProvider>
  );
}
